"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../../context");
const styling_1 = require("../../../../styling");
const utils_1 = require("../../../../styling/utils");
const Select_1 = tslib_1.__importDefault(require("../../../../ui-lib/Inputs/Select"));
const ErrorBoundary_1 = require("../../../ErrorBoundary");
function getResolution(msc) {
    var _a, _b;
    if (((_b = (_a = msc.settings) === null || _a === void 0 ? void 0 : _a.video) === null || _b === void 0 ? void 0 : _b.height) != null) {
        return msc.settings.video.height;
    }
    const resolution = msc.resolution;
    if (resolution == null) {
        return null;
    }
    if (Array.isArray(resolution)) {
        return resolution[0];
    }
    return typeof resolution === "number" ? resolution : resolution.ideal;
}
/**
 * @todo: Possibly refactor Select Components
 *
 */
const ModularQualitySelect = (0, mobx_react_lite_1.observer)(({ classes = {}, maxResolutionHeight, ...props }) => {
    var _a, _b;
    /**
     * Component Name (for error msg)
     */
    const componentName = "<ResolutionSelect/>";
    /**
     * Access EncoderUiContext & destructure API state
     */
    const ctx = (0, react_1.useContext)(context_1.EncoderUiContext);
    /**
     * Throw error (and trigger ErrorBoundary) if store is undefined.
     * */
    (0, ErrorBoundary_1.useUndefinedStoreError)((ctx === null || ctx === void 0 ? void 0 : ctx.mediaStreamController) != null, componentName);
    const availableResolutions = ctx.currentAvailableResolutions.filter((r) => maxResolutionHeight == null || r <= maxResolutionHeight);
    /**
     * On input change handler to (1) update API and (2) update component
     * <select> value with user selected resolution.
     */
    const selectResolution = (ev) => {
        ctx.mediaStreamController.resolution = Number(ev.target.value);
    };
    const mergedClasses = (0, styling_1.useStyles)({ source: classes, target: {} }, "select");
    const mergedStyles = (0, utils_1.mergeStylesObjects)(classes, {});
    /**
     * Wrap onChange function in global Error handler (to trigger ErrorBoundary).
     * */
    const handleInputChange = (0, ErrorBoundary_1.useUIEventError)(selectResolution, componentName);
    return (react_1.default.createElement(Select_1.default, { ...props, classes: mergedStyles, label: "Quality", onChange: handleInputChange, value: (_b = (_a = getResolution(ctx.mediaStreamController)) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : undefined },
        react_1.default.createElement("option", { disabled: true, value: "", className: mergedClasses.options }, "Select a Resolution"),
        availableResolutions.map((item) => (react_1.default.createElement("option", { key: item, value: item, className: mergedClasses.options }, `${item}p`)))));
});
// eslint-disable-next-line react/function-component-definition
const QualitySelectWithErrorBoundary = ({ classes = {}, maxResolutionHeight, ...props }) => {
    const mergedClasses = (0, styling_1.useStyles)({ source: classes, target: {} }, "select");
    const mergedStyles = (0, utils_1.mergeStylesObjects)(classes, {});
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => {
            var _a;
            return (react_1.default.createElement(Select_1.default, { ...props, value: "", disabled: true, classes: mergedStyles, label: "Resolution: Unavailable" },
                react_1.default.createElement("option", { value: "", className: mergedClasses === null || mergedClasses === void 0 ? void 0 : mergedClasses.options }, (_a = props.fallbackText) !== null && _a !== void 0 ? _a : " Resolution Unavailable")));
        } },
        react_1.default.createElement(ModularQualitySelect, { maxResolutionHeight: maxResolutionHeight, classes: classes, ...props })));
};
exports.default = QualitySelectWithErrorBoundary;
//# sourceMappingURL=ResolutionSelect.js.map